/*
 *  -----------------------------------------------------------------------
 *    <copyright file="not-found.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React from 'react';

const NotFound = () => <p>Page not found</p>;

export default NotFound;
